import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoArrowDownCircleOutline, IoCheckmarkCircle, IoCloseCircleSharp, IoConstructSharp, IoDocument, IoReturnUpForward } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";

const FormEditMyTicket = () => {
  const [ticket_id, setTicketId] = useState("");
  const [service_id, setServiceId] = useState("");
  const [description, setDesc] = useState("");
  const [technician, setTechnician] = useState("");
  const [product_name, setProductName] = useState("");
  const [serialnumber, setSerialNumber] = useState("");
  const [url, setUrl] = useState("");
  const [repair_status, setRepairStatus] = useState("");
  const [clientName, setClientName] = useState("");
  const [start_time, setStartTime] = useState("");
  const [end_time, setEndTime] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [msg, setMsg] = useState("");
  const { id, idservice } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const getTicketById = async () => {
      try {
        const result = await axios.get(`${API_BASE_URL}/mytickets/${id}`, {
          headers: {
            'X-API-Key': API_KEY
          },
        });
        const idservice = result.data.id;

        const response = await axios.get(`${API_BASE_URL}/myservices/${idservice}`, {
          headers: {
            'X-API-Key': API_KEY
          },
        });
       // console.log(response.data);

        setTicketId(response.data.ticket.ticket_id);
        setDesc(response.data.description);
        setRepairStatus(response.data.repair_status);        
        setTechnician(response.data.technician);
        setServiceId(response.data.service_id);
        setProductName(response.data.ticket.product.name);
        setSerialNumber(response.data.ticket.product.serialnumber);
        setManufacturer(response.data.ticket.product.manufacturer);
        setUrl(response.data.ticket.product.url);
        setClientName(response.data.contract.client.name);

        const startdate = new Date(response.data.start_time);
        startdate.setMinutes(startdate.getMinutes() - startdate.getTimezoneOffset());
        const starttime = startdate.toISOString().slice(0,16);
        setStartTime(starttime);
       // console.log(response.data.end_time);
        if(response.data.end_time===null){
            setEndTime("");
        }else{
            const enddate = new Date(response.data.end_time);
            enddate.setMinutes(enddate.getMinutes() - enddate.getTimezoneOffset());
            const endttime = enddate.toISOString().slice(0,16);
            setEndTime(endttime);
        }

      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getTicketById();
  }, [id, idservice]);
  
  return (
    <div className="panel is-link">
      <p className="panel-heading">INFO TICKET REPAIR, NO_TICKET: {ticket_id}</p>
      <div className="card is-shadowless p-2">
        <div className="field is-6">
            <label className="label">Customer_Name</label>
            <div className="control">
                <input
                type="text"
                className="input"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
                disabled
                />
            </div>     
        </div>  
        <h1 className="title is-size-5 mt-4">Product Info:</h1>
        <table className="table is-bordered is-striped is-fullwidth is-size-7">
            <thead>
                <tr>
                  <th style={{width: "1%"}}>No</th>
                  <th className="has-text-centered">Image</th>
                  <th className="has-text-centered">Product</th>  
                  <th className="has-text-centered">Serial_Number</th>  
                  <th className="has-text-centered">Merek/Manufacturer</th>        
                  <th className="has-text-centered">Problem_Description</th>                  
                </tr>
            </thead>
            <tbody>              
                <tr>
                    <td>{1}</td>
                    <td className="has-text-centered">
                      <figure className="image is-48x48">
                        <img src={url} alt="Image" />
                      </figure>
                    </td>
                    <td>{product_name}</td>  
                    <td className="has-text-centered">{serialnumber}</td>  
                    <td>{manufacturer}</td>
                    <td>{description}</td>        
                </tr>            
            </tbody>
        </table> 
        <p className="has-text-left has-text-danger">{msg}</p>
          <div className="field columns">
            <div className="column is-3">
              <label className="label">Service_Id</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={service_id}
                  onChange={(e) => setServiceId(e.target.value)}
                  disabled
                />
              </div>
            </div>
            <div className="column is-3">
                <label className="label">Technician</label>
                <div className="control">
                <input
                  type="text"
                  className="input"
                  value={technician}
                  onChange={(e) => setTechnician(e.target.value)}
                  disabled
                />
                </div>     
            </div>  
            <div className="column is-3">
                <label className="label">Start_Time</label>
                <div className="control">
                    <input className="input"
                    type="datetime-local"
                    id="start_time"
                    name="star_time"
                    value={start_time} // Controlled component
                    disabled/>
                </div>    
            </div>
            <div className="column is-3">
                <label className="label">End_Time</label>
                <div className="control">
                    {end_time==="" ? ( 
                        <input className="input"
                        type="text"
                        id="end_time"
                        name="end_time"
                        value="-" // Controlled component
                        disabled/>
                    ):(
                        <input className="input"
                        type="datetime-local"
                        id="end_time"
                        name="end_time"
                        value={end_time} // Controlled component
                        disabled/>
                    )}
                </div>    
            </div>    
          </div>
          <div className="field columns">
            <div className="column is-full">
                <label className="label">Repair_Status</label>
                  <ul className="steps has-content-centered">
                    <li className={(repair_status==='OPEN' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoDocument /></span>
                      <div className="steps-content">
                        <p className="is-size-4">OPEN</p>
                        <p>Entrance Ticket</p>
                      </div>
                    </li>
                    <li className={(repair_status==='RECEIVED' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoArrowDownCircleOutline /></span>
                      <div className="steps-content">
                        <p className="is-size-4">RECEIVED</p>
                        <p>Items Coming into Repair</p>
                      </div>
                    </li>
                    <li className={(repair_status==='IN PROGRESS' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoConstructSharp /></span>
                      <div className="steps-content">
                        <p className="is-size-4">IN PROGRESS</p>
                        <p>Repair Work Process</p>
                      </div>
                    </li>
                    <li className={(repair_status==='COMPLETED' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoCheckmarkCircle /></span>
                      <div className="steps-content">
                        <p className="is-size-4">COMPLETED</p>
                        <p>Repair Process Completed</p>
                      </div>
                    </li>
                    <li className={(repair_status==='RETURNED' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoReturnUpForward /></span>
                      <div className="steps-content">
                        <p className="is-size-4">RETURNED</p>
                        <p>Customer Return Process</p>
                      </div>
                    </li>
                    <li className={(repair_status==='CLOSED' ? 'steps-segment is-active' : 'steps-segment')}>
                      <span className="steps-marker"><IoCloseCircleSharp /></span>
                      <div className="steps-content">
                        <p className="is-size-4">CLOSED</p>
                        <p>Closed Ticket</p>
                      </div>
                    </li>
                  </ul>
            </div>
          </div>
         
          <div className="field">
              <Link to="/mytickets">
              <button className="button is-warning mr-1">
                  Close
              </button>
              </Link>
          </div>                        
    </div>
  </div>
  );
};

export default FormEditMyTicket;